import { Button } from "antd";
import React from "react";
import "./NextStepBtnComponent.scss";

import { INextStepBtnComponentProps } from "./NextStepBtnInterfaces.types";
import { useNavigate } from "react-router-dom";
import { StorageInterface } from "store/StorageInterface";
import { useSelector } from "react-redux";
import userDataService from "store/UserData/UserDataService";

function NextStepBtnComponent(props: INextStepBtnComponentProps) {
  const userData = useSelector((state: StorageInterface) => {
    return state.userDataSlice;
  });
  let navigate = useNavigate();

  const saveUserOptionSelected = (option: any) => {
    let queryParams = {
      email: `${userData.email}`,
      params: [
        {
          name: "TRANS_SIM_USER_FULLNAME",
          value: `${userData.fullname}`,
        },
        {
          name: "TRANS_SIM_USER_SELECTION",
          value: `${option}`,
        },
      ],
    };
    userDataService.saveUserData(queryParams);
    let addRoleToData = {
      fullname: userData.fullname,
      email: userData.email,
      role: props.userOptionSelected
        ? Number(props.userOptionSelected?.value) === 2
          ? "seller"
          : "buyer"
        : "seller",
    };
    //adding selected btn options for user role, to slice
    userDataService.setUserData(addRoleToData);
  };

  const navigateTo = () => {
    let path = props.value;
    navigate(path);

    /* Saving user data and selected option,if selection was executed when user select new option
      props.userOptionSelected take text value */
    if (props.userOptionSelected && props.userOptionSelected !== undefined) {
      saveUserOptionSelected(props.userOptionSelected.text);
    }
  };

  return (
    <div className={`NextStepBtn ${props.className}`}>
      <Button
        id={props.id || ""}
        value={props.value}
        disabled={props.disabled}
        className={`btn  ${props.btnClassName}`}
        onClick={navigateTo}
        block={true}
      >
        {props.text}
      </Button>
    </div>
  );
}

NextStepBtnComponent.defaultProps = {
  text: "Siguiente",
  className: "",
  btnClassName: "",
};

export default NextStepBtnComponent;
